import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { getExperience } from "../../utils";

function Home2() {
  const experience = getExperience("2022-12-01");

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              A <b className="purple">Full Stack Developer</b> with{" "}
              <b className="purple">{experience}+ years</b> of professional
              experience delivering scalable, production-grade web applications
              from architecture to deployment.
              <br />
              <br />
              On the frontend I craft responsive, accessible UIs with{" "}
              <b className="purple">React.js, Next.js &amp; TypeScript</b>. On
              the backend I build robust APIs and microservices with{" "}
              <b className="purple">Node.js, Express &amp; GraphQL</b>, backed
              by <b className="purple">PostgreSQL, MongoDB &amp; Redis</b>.
              <br />
              <br />
              Experienced with{" "}
              <b className="purple">AWS, Docker &amp; CI/CD pipelines</b> —
              shipping reliable software with automated testing (Jest, Cypress)
              and real-time features via{" "}
              <b className="purple">WebSockets &amp; WebRTC</b>.
              <br />
              <br />
              <i>
                Open to new opportunities — let's build something impactful
                together.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>

        <Row className="home-stats-row">
          {[
            { number: "10+",          label: "Projects Delivered" },
            { number: `${experience}+`, label: "Years Experience"   },
            { number: "15+",          label: "Technologies"         },
          ].map((stat, i) => (
            <Col md={4} key={i} className="home-stat-item">
              <h2 className="stat-number purple">{stat.number}</h2>
              <p className="stat-label">{stat.label}</p>
            </Col>
          ))}
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/chandraprakash9589"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/chandraprakash-kushwaha-a9a672269/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
